module.exports = ":host{display:none}"